import * as React from 'react'

import cn from 'classnames'

import './index.styles.css'

export type Types = 'brand' | 'primary' | 'radical' | 'negative' | 'wrong' | 'darker' | 'accent'
type Sizes = 'small' | 'medium'
interface Props {
  compact?: boolean
  color?: string
  size?: Sizes
  type?: Types
}

const separatorSizeClass: Record<Sizes, string> = {
  small: 'Separator_separator_small',
  medium: 'Separator_separator_medium',
}

const colorVariantClass: Record<Types, string> = {
  brand: 'Separator_colorVariants_brand',
  primary: 'Separator_colorVariants_primary',
  radical: 'Separator_colorVariants_radical',
  negative: 'Separator_colorVariants_negative',
  wrong: 'Separator_colorVariants_wrong',
  darker: 'Separator_colorVariants_darker',
  accent: 'Separator_colorVariants_accent',
}

const Separator = ({ color, size = 'medium', type = 'radical', compact }: Props) => {
  return (
    <div
      style={
        color
          ? {
              borderColor: color,
            }
          : {}
      }
      className={cn(
        separatorSizeClass[size],
        colorVariantClass[type],
        compact && 'Separator_compact'
      )}
    />
  )
}

export default Separator
